
import React from 'react';
import cnbcLogo from '../assets/CNBC.png';
import bwLogo from '../assets/BW.png';
import htLogo from '../assets/TIMES.png';
import etSmallBizLogo from '../assets/ET.png';

const FeaturedIn = () => {
    return (
        <div className="w-full h-auto bg-gradient-to-b from-[#DA7902] to-[#E2B47C] flex flex-col items-center justify-center">
            <div className="text-center mb-8">
                <h2 className="text-white text-3xl font-semibold mt-10">Featured In</h2>
                <p className="text-white text-lg mt-8">A glimpse of how we are changing the Indian Bike Rental Industry, one bike at a time</p>
            </div>
            <div className="flex items-center justify-center w-full px-4 mb-14">
                <button className="flex items-center justify-center w-12 h-12 rounded-full border border-white text-white text-2xl mr-4">
                    {'<'}
                </button>
                <div className="flex gap-4 overflow-hidden">
                    {/* For desktop screens, display all logos */}
                    <div className="hidden sm:flex gap-4">
                        <img src={cnbcLogo} alt="CNBC Logo" className="h-20" />
                        <img src={bwLogo} alt="BW Businessworld Logo" className="h-20" />
                        <img src={htLogo} alt="Hindustan Times Logo" className="h-20" />
                        <img src={etSmallBizLogo} alt="ET SmallBiz Logo" className="h-20" />
                    </div>

                    {/* For mobile screens, display only 2 logos */}
                    <div className="sm:hidden flex gap-4">
                        <img src={cnbcLogo} alt="CNBC Logo" className="h-20" />
                        
                    </div>
                </div>
                <button className="flex items-center justify-center w-12 h-12 rounded-full border border-white text-white text-2xl ml-4">
                    {'>'}
                </button>
            </div>
        </div>
    );
};

export default FeaturedIn;
